/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_ConditionInputs */

const cs_node_condition = /** @type {(inputs: Node_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podmínka`)
};

const en_node_condition = /** @type {(inputs: Node_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condition`)
};

/**
* | output |
* | --- |
* | "Condition" |
*
* @param {Node_ConditionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const node_condition = /** @type {((inputs?: Node_ConditionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_ConditionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_node_condition(inputs)
	return cs_node_condition(inputs)
});